
(function (global, trackingData) {
    const data = trackingData || {};
    global.CsnInsights = global.CsnInsights || {};

    Object.keys(data).forEach(key => global.CsnInsights[key] = data[key]);

})(window, tracking_data);
